import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UICustomRadio } from './ui-custom-radio';



@NgModule({
	declarations: [UICustomRadio],
	imports: [
		CommonModule
	],
	exports: [UICustomRadio]
})
export class UICustomRadioModule { }
